import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';

export type WineBadgeProps = {
  label: string;
  icon?: SvgComponent;
  iconOnClick?: () => void;
};

const Wrapper = styled.div`
  cursor: auto;
  width: 50px;
  height: 48px;
  display: flex;
  justify-content: center;
`;

const LabelWrapper = styled(UIText).attrs({ size: 'md' })`
  position: absolute;
  font-weight: bold;
  color: ${theme.colors.primary.white};
  z-index: 1;
  cursor: auto;
  top: 11px;
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: ${theme.colors.neutrals.border.dark};
  padding-left: 4px;
`;

const SvgWrapper = styled.div`
  position: absolute;
  width: 50px;
  max-height: 48px;
  cursor: auto;
  svg {
    fill: ${theme.colors.primary.black};
    width: 50px;
    max-height: 48px;
    cursor: pointer;
    padding-left: 3px;
  }
`;

export const WineBadge: React.FC<WineBadgeProps> = ({
  label,
  icon: Icon,
  iconOnClick,
  ...props
}) => {
  const handleOnClick = (e: MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    iconOnClick && iconOnClick();
  };
  return (
    <Wrapper {...props}>
      <LabelWrapper>{label}</LabelWrapper>
      <SvgWrapper>{Icon && <Icon onClick={handleOnClick} />}</SvgWrapper>
    </Wrapper>
  );
};
